export const addItemsToShoppinglist = (shoppingListItems, itemsToAdd) => {

}

export const removeItemsFromShoppinglist = (shoppingListItems, itemsToRemove) => {
    
}

export const mergeListItems = (listToUpdateIngredients, itemsToMerge) => {
    let matchStoreItemIndexes = []

    try {
        const mergedIngredients = listToUpdateIngredients.map((listToUpdateItem) => {
            const itemToMerge = itemsToMerge.find((itemToMerge) => listToUpdateItem?.value === itemToMerge?.value)

            if(itemToMerge) {
                const listItemCopy = {...listToUpdateItem}
                listItemCopy.quantity = parseFloat(listToUpdateItem.quantity) + parseFloat(itemToMerge.quantity)
                
                const storeItemsToMoveRemoveMatchIndex = storeItemsToMove.findIndex(item => {
                    return item.value === itemToMerge.value
                }) 

                matchStoreItemIndexes.push(storeItemsToMoveRemoveMatchIndex)

                return listItemCopy
            }

            return listToUpdateItem
        })

        const storeItemsToMove = [...itemsToMerge].filter((_, index) => !matchStoreItemIndexes.includes(index))

        return [...mergedIngredients, ...storeItemsToMove]        
    } catch (error) {
        throw new Error('error in mergeListItems')
    }
}